import React, { useState } from 'react';
import styles from './FAQ.module.css';

const faqData = [
  {
    id: 1,
    question: 'What courses does Bspark Software Technologies offer?',
    answer: 'We offer a wide range of courses including Full Stack Development (MERN, MEAN), Data Science, Machine Learning, UI/UX Design, Cloud Computing (AWS, Azure), and various programming languages like Python and Java. Our curriculum is designed to be industry-relevant and updated regularly.',
  },
  {
    id: 2,
    question: 'Are the instructors certified and experienced?',
    answer: 'Yes, all our instructors are seasoned professionals with years of industry experience. They bring real-world knowledge and practical insights to the classroom, ensuring you get hands-on training that prepares you for a career in tech.',
  },
  {
    id: 3,
    question: 'What are the prerequisites for enrolling in a course?',
    answer: 'Prerequisites vary by course. For introductory courses, a basic understanding of computer fundamentals is often sufficient. For advanced courses, a foundational knowledge of programming might be required. You can find specific requirements on each course page.',
  },
  {
    id: 4,
    question: 'Do you provide placement assistance after course completion?',
    answer: 'Absolutely. We have a dedicated placement cell that assists students with resume building, interview preparation, and connecting with our network of hiring partners. We have a strong track record of successful placements in top tech companies.',
  },
  {
    id: 5,
    question: 'Can I get a demo or trial class before enrolling?',
    answer: 'Yes, we encourage prospective students to attend a free demo session. This gives you a chance to experience our teaching methodology, interact with instructors, and get a feel for our learning environment. You can schedule a demo on our website.',
  },
  {
    id: 6,
    question: 'What is the batch size for your courses?',
    answer: 'We maintain small batch sizes to ensure personalized attention for every student. This allows for better interaction with instructors and peer-to-peer learning. The average batch size is between 15-20 students.',
  },
];

const FAQ = () => {
  const [openId, setOpenId] = useState(null);

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className={styles.faqSection}>
      <div className={styles.container}>
        <h2 className={styles.sectionHeading}>Frequently Asked Questions</h2>
        <div className={styles.faqList}>
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className={`${styles.faqItem} ${openId === faq.id ? styles.active : ''}`}
            >
              <div className={styles.faqQuestion} onClick={() => handleToggle(faq.id)}>
                <h3>{faq.question}</h3>
                <span className={styles.toggleIcon}>
                  {openId === faq.id ? '−' : '+'}
                </span>
              </div>
              <div className={styles.faqAnswerContainer}>
                <div className={styles.faqAnswer}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;